/**
 * =============================================================================
 * product-tile-variant-picker.js
 * =============================================================================
 * An alternative product tile, which expects the full variant selection 
 * experience as used on the product page to be available, but presented e.g. as
 * a modal.
 * 
 * Originally put in place for AB Handling. Makes use of
 * VariantStateManager to handle the variant selection state.
 * 
 * Because this doesn't have the full product form, it doesn't have the same
 * functionality with respect to line item properties etc. However, this would
 * not be a huge effort to add if required.
 * =============================================================================
 */

import VariantStateManager from './variant-state-manager'

class ProductTileVariantPicker extends HTMLElement {
  buttons;
  quantity;

  variantStateManager;
  
  constructor() {
    super();

    // The tile might have multiple add buttons, so we use an array rather than
    // just storing one (e.g. desktop / mobile)
    this.buttons = this.querySelectorAll("[name='add']");
    this.buttons.forEach(element => {
      element.addEventListener("click", this.onTileAddToCartClick.bind(this));
    });
    
    // TODO: A selling plan selector.
    // TODO: Line item property support
    // TODO: Use this for all tile quick buy scenarios, not just with the full picker

    let variantSelect = this.querySelector("#variant-select");
    let sellingPlanSelect = this.querySelector("#selling-plan-select");
    this.variantStateManager = new VariantStateManager(this, variantSelect, sellingPlanSelect);

    this.quantity = this.querySelector("[name='quantity']");
    this.quantity.addEventListener("change", e => {
      let event = new CustomEvent("quantity:changed", { detail: {
        variant: this.variantStateManager.currentVariant,
        quantity: e.currentTarget.value
      }});
      this.dispatchEvent(event);
    });
  }

  /**
   * Determine & add the correct variant to the cart
   * 
   * @param {Event} e The click event 
   */
  onTileAddToCartClick(e) {
    // Set visual state of all add buttons
    this.buttons.forEach(element => {
      element.classList.add('loading');
      element.querySelector(".spinner-overlay")?.classList.remove('d-none');
    });

    // Add the selected variant to the cart. Delay slightly so it feels like
    // something is happening (otherwise it's basically instant!)
    MP.Extensions.Cart.add([{ 
      id: this.variantStateManager.currentVariant.id,
      quantity: parseInt(this.quantity.value) || 1
    }])
      .then(() => { 
        setTimeout(this.onVariantAddedToCart(), 1500); 
      });
  }

  onVariantAddedToCart() {
    // Reset visual state of all add buttons
    this.buttons.forEach(element => {
      element.classList.remove('loading');
      element.querySelector(".spinner-overlay")?.classList.add('d-none');
    });
  }
}

export default ProductTileVariantPicker;